export const ciEquals = (a: string, b: string) => {
	return a.toLowerCase() === b?.toLowerCase();
};
